export default {
  Scale: {
    x: 100,
    y: 100,
    z: 0,
    length: 350,
    size: 167,
  },
  Belt: {
    x: 100,
    y: 100,
    z: 0,
    length: 190,
    size: 90,
  },
  Bin: {
    x: 100,
    y: 100,
    z: 0,
    length: 110,
    size: 110,
  },
  Switch: {
    x: 100,
    y: 100,
    z: 0,
    length: 50,
    size: 50,
  },
  Aerator: {
    x: 100,
    y: 100,
    z: 0,
    length: 50,
    size: 50,
  },
  Vibrator: {
    x: 100,
    y: 100,
    z: 0,
    length: 50,
    size: 50,
  },
  Screw: {
    x: 100,
    y: 100,
    z: 0,
    length: 150,
    size: 100,
  },
  Horn: {
    x: 100,
    y: 100,
    z: 0,
    length: 50,
    size: 50,
  },
  DustCollector: {
    x: 100,
    y: 100,
    z: 0,
    length: 50,
    size: 50,
  },
  Pump: {
    x: 100,
    y: 100,
    z: 0,
    length: 100,
    size: 270,
  },
  AnalogInput: {
    x: 100,
    y: 100,
    z: 0,
    length: 100,
    size: 50,
  },
  AnalogSwitch: {
    x: 100,
    y: 100,
    z: 0,
    length: 100,
    size: 50,
  },
  SlumpMeter: {
    x: 100,
    y: 100,
    z: 0,
    length: 85,
    size: 50,
  },
  Tank: {
    x: 100,
    y: 100,
    z: 0,
    length: 160,
    size: 160,
  },
  Mixer: {
    x: 160,
    y: 160,
    z: 0,
    length: 150,
    size: 150,
  },
  Boot: {
    x: 100,
    y: 100,
    z: 0,
    length: 100,
    size: 60,
  },
  TruckDevice: {
    x: 100,
    y: 100,
    z: 0,
    length: 130,
    size: 130,
  },
  AirCompressor: {
    x: 100,
    y: 100,
    z: 0,
    length: 110,
    size: 110,
  },
  Diverter: {
    x: 100,
    y: 100,
    z: 0,
    length: 85,
    size: 50,
  },
  RemoteDisplay: {
    x: 100,
    y: 100,
    z: 0,
    length: 140,
    size: 90,
  },
  ManualPanel: {
    x: 100,
    y: 100,
    z: 0,
    length: 110,
    size: 70,
  },
  Scoreboard: {
    x: 100,
    y: 100,
    z: 0,
    length: 100,
    size: 130,
  },
};
